export const BLOG_POST = `
query BlogPost($slug: String!, $locale: I18NLocaleCode!, $status: PublicationStatus!) {
  blogPosts(filters: { slug: { eq: $slug } }, pagination: { limit: 1 }, locale: $locale, status: $status) {
    documentId
    title
    slug
    Datum
    sections {
      ... on ComponentLayoutTextImage {
        __typename
        id
        title
        description
        content
        image {
          url
          alternativeText
        }
        reverseOrder
        textImageOrientation: orientation
      }
      ... on ComponentLayoutImageBanner {
        __typename
        id
        bannerImages: images {
          image {
            url
            alternativeText
          }
        }
      }
      ... on ComponentLayoutCardColumns {
        __typename
        id
        cards {
          image {
            url
            alternativeText
          }
          description
          button {
            url
            label
          }
        }
      }
      ... on ComponentLayoutIntroSection {
        __typename
        id
        hexagonImages: images {
          image {
            url
            alternativeText
          }
        }
        title
        teaser
        introContent: content
        showMascot
      }
      ... on ComponentLayoutTextVideo {
        __typename
        id
        title
        description
        videoTextContent: content
        video {
          url
          alternativeText
        }
        reverseOrder
        orientation
      }
    }
    previewImage {
      url
      alternativeText
    }
    headerImage {
      url
      alternativeText
    }
    createdAt
    updatedAt
    publishedAt
    locale
  }
}
`;
